import { SHORT_TIME_FORMAT } from 'constants/dates';
import { DateTime, Interval } from 'luxon';
import { AppointmentStatus } from 'models/Appointment';
import { EngineerSchedule } from 'models/Schedule';
import { useMemo } from 'react';

export function useEngineerUtilisation(
  engineerSchedule: EngineerSchedule,
  engineerTravelTime: number
) {
  const engineerTotalJobsLength = useMemo(
    () =>
      engineerSchedule.assignments.reduce(
        (acc, assignment) =>
          assignment.appointment?.status !== AppointmentStatus.CANCELLED
            ? acc + assignment.length
            : acc,
        0
      ),
    [engineerSchedule.assignments]
  );

  const engineerStartTime = DateTime.fromFormat(
    engineerSchedule.engineer.startTime,
    SHORT_TIME_FORMAT
  );

  const engineerEndTime = DateTime.fromFormat(
    engineerSchedule.engineer.endTime,
    SHORT_TIME_FORMAT
  );

  const engineerShiftTimeInMinutes = Interval.fromDateTimes(
    engineerStartTime,
    engineerEndTime
  ).length('minutes');

  const engineerUtilisationPercentage = Math.round(
    ((engineerTravelTime + engineerTotalJobsLength) /
      engineerShiftTimeInMinutes) *
      100
  );

  return engineerUtilisationPercentage;
}
